import { trackClick } from "../lib/analytics";
import { useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Mail, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    trackClick("newsletter_signup");
    setState("loading");
    try {
      await api.post("/newsletter/subscribe", { email });
      setState("done");
      toast.success("Merci ! Vous êtes inscrit à la newsletter.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
      setState("idle");
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md w-full" data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className="w-4 h-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          type="email"
          required
          placeholder="votre@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="pl-9 bg-white/[0.03] border-white/10"
          data-testid="newsletter-email"
          disabled={state === "done"}
        />
      </div>
      <Button type="submit" disabled={state !== "idle"} className="bg-emerald-500 text-black hover:bg-emerald-300" data-testid="newsletter-submit">
        {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : state === "done" ? <Check className="w-4 h-4" /> : "S'inscrire"}
      </Button>
    </form>
  );
}
